@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="card company-document-revision-card">
  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">New Quality Document Revision</h3>
    @if (code) {
      <span class="badge company-document-code-badge">{{ code }}</span>
    }
    @if (status) {
      <span [class]="'badge company-document-status-badge ' + statusBadgeClass">{{ statusLabel }}</span>
    }
  </div>

  <div class="card-body">
    <form [formGroup]="form">

      <h5 class="company-document-section-title">Quality Document</h5>
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-6">
          <input-field
            label="Dept."
            [inputFormControl]="getControl('documentDepartment')"
            [type]="'text'"
            [readonly]="true">
          </input-field>
        </div>
        <div class="col-lg-6 col-md-8 col-sm-12">
          <input-field
            label="Doc. Name"
            [inputFormControl]="getControl('documentName')"
            [type]="'text'"
            [readonly]="true">
          </input-field>
        </div>
      </div>

      <h5 class="company-document-section-title">Quality Document Revision</h5>
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-6">
          <input-field
            label="Revision"
            [inputFormControl]="getControl('code')"
            [type]="'text'"
            [readonly]="true">
          </input-field>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-6">
          <div class="form-group">
            <label class="fw-bold company-document-field-label">Date</label>
            <div class="input-group shadow-sm">
              <input
                type="date"
                class="form-control"
                formControlName="date"
                [class.is-invalid]="hasError('date')" />
            </div>
            @if (hasError('date')) {
              <div class="text-danger small">
                <i class="fa fa-exclamation-circle me-1"></i>{{ errorMessage('date') }}
              </div>
            }
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <textarea-field
            label="Description"
            placeholder="Describe what changed in this revision"
            [height]="160"
            [textareaFormControl]="getControl('description')">
          </textarea-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="form-group signature-field">
            <label class="fw-bold company-document-field-label">Reviewed</label>
            <select-field
              [selectFormControl]="getControl('reviewedUserId')"
              [options]="userOptions">
            </select-field>
            @if (isEditMode && (reviewedSigned || canSignAsReviewer)) {
              <div class="signature-state">
                @if (reviewedSigned) {
                  <span class="text-success">
                    <i class="fa fa-check me-1"></i>Signed on {{ reviewedDate }}
                  </span>
                } @else if (canSignAsReviewer) {
                  <button type="button" class="btn btn-sm btn-success" (click)="signAsReviewer()">Sign</button>
                }
              </div>
            }
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="form-group signature-field">
            <label class="fw-bold company-document-field-label">Approved</label>
            <select-field
              [selectFormControl]="getControl('approvedUserId')"
              [options]="userOptions">
            </select-field>
            @if (isEditMode && (approvedSigned || canSignAsApprover)) {
              <div class="signature-state">
                @if (approvedSigned) {
                  <span class="text-success">
                    <i class="fa fa-check me-1"></i>Signed on {{ approvedDate }}
                  </span>
                } @else if (canSignAsApprover) {
                  <button type="button" class="btn btn-sm btn-success" (click)="signAsApprover()">Sign</button>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </form>

    <div class="row">
      <div class="col-lg-6 col-md-12">
        <company-document-revision-attachments
          [companyDocumentRevisionId]="companyDocumentRevisionId"
          [attachments]="attachments"
          [readonlyAttachmentsPanel]="attachmentsReadonly"
          [canRemoveAttachment]="canRemoveAttachment"
          (attachmentUploaded)="onAttachmentsChanged()"
          (attachmentRemoved)="onAttachmentsChanged()"
          (pendingFilesChange)="onPendingFilesChange($event)">
        </company-document-revision-attachments>
      </div>
    </div>
  </div>

  <div class="card-footer">
    <div class="d-flex flex-wrap justify-content-center align-items-center gap-2 my-2">
      @if (canSave) {
        <button type="button" class="btn btn-primary" (click)="submitForm()">Save</button>
      }
      @if (canRequestConfirmation) {
        <button
          type="button"
          class="btn btn-success"
          [disabled]="isRequestConfirmationDisabled"
          [title]="isRequestConfirmationDisabled ? 'Reviewer and approver have already signed' : ''"
          (click)="requestConfirmation()">
          Request Confirmation
        </button>
      }
      @if (canMoveInUse) {
        <button type="button" class="btn btn-warning" (click)="moveInUse()">Move in use</button>
      }
      @if (canDelete) {
        <button type="button" class="btn btn-danger" (click)="deleteRevision()">Delete</button>
      }
      <button type="button" class="btn btn-secondary" (click)="goBackToDocument()">Back to document</button>
    </div>
  </div>
</div>
